import React from 'react'
import '../../components/legacy/Legacy.css'
const Legacy = () => {

return(<div className='legacy-container'>
<iframe title="biocare final report" width="100%" height="100%" src="https://app.powerbi.com/reportEmbed?reportId=eb0dd48d-9798-41da-bd68-d587bbb70c32&autoAuth=true&ctid=6e41ab10-20c3-4ab4-854a-599180a4ba62" frameborder="0" allowFullScreen="true"></iframe>
</div>)
}

export default Legacy;